import { addBasePath } from '~/helpers/addBasePath';

// TODO env variable. Check if path already have '/media/catalog/category'.
export const getCategoryImagePath = (path: string): string => `${process.env.VSF_MAGENTO_BASE_URL}${path}`;
export const getCategoryImage = (thumbnail_image: string | undefined | null) => {
  if (!thumbnail_image) return addBasePath('/icon.png');
  return getCategoryImagePath(thumbnail_image);
};
